//================= [JS] ======================================
import {i18n} from '@/common/i18n';
import {Routes} from '@/common/enums/Routes';
//================= [VUE COMPONENTS] ==========================

export const contractRoutes = [
  {
    path: i18n.global.t('routes.contract'),
    name: Routes.CONTRACT,
    component: () => import('@/components/contract/ContractShow.vue'),
    meta: {
      title: i18n.global.t('titles.contract'),
      active: 'contract',
      userType: 'admin',
    },
  },
];
